mutation CreateImpactMeasurementItem(
  $impactMeasurementItemInput: ImpactMeasurementItemInput!
) {
  createImpactMeasurementItem(
    input: { impactMeasurementItemInput: $impactMeasurementItemInput }
  ) {
    impactMeasurementItem {
      id
    }
  }
}
